export default {
  latitude: 22.532209, // 纬度，浮点数，范围为90 ~ -90
  longitude: 113.984634, // 经度，浮点数，范围为180 ~ -180。
  name: "深圳华侨城洲际大酒店", // 位置名
  address: "深圳华侨城洲际大酒店", // 地址详情说明
  region: "深圳", // 地区
  mapKey: "YQPBZ-XOAKZ-I2SXF-7477G-WEP73-FTFVO", // 腾讯地图key
  wxConfig: {
    scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
  },
  mapConfig: {
    zoom: 17.2, //设置地图缩放级别
    pitch: 43.5, //设置俯仰角
    rotation: 45, //设置地图旋转角度
  },
};
